import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import imagem1 from "../../images/imagem13.jpg";
import Globais from "../../css/Globais";
import familiaResort from "../../images/familia-resort.jpg";

const HeroWrapper = styled.section`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  padding: 3rem 1.5rem;
  background-color: #f9f9f9;
  text-align: center;

  @media (min-width: 768px) {
    flex-direction: row;
    text-align: left;
    padding: 5rem 4rem;
  }
`;

const Content = styled.div`
  flex: 1;
  max-width: 600px;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    font-size: 2.6rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const CTAButton = styled.a`
  background-color: #0077cc;
  color: white;
  padding: 0.9rem 1.8rem;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  border-radius: 6px;
  transition: background 0.3s ease;

  &:hover {
    background-color: #005fa3;
  }
`;

const ImageArea = styled.div`
  flex: 1;
  width: 100%;
  max-width: 600px;
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    margin-bottom: 0;
    padding-left: 2rem;
  }
`;

const HeroImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 12px;
  object-fit: cover;
`;




const HeroSection = () => {
  return (
    <HeroWrapper>
      <Content>
        <Title>
          Tem uma cota parada? <br />
          Transforme em renda, viagens ou oportunidade de venda — com mais resultado e menos dor de cabeça.
        </Title>
        <Subtitle>
          Cadastre sua multipropriedade e tenha controle real sobre o que é seu —
          com liberdade, renda ou até uma saída segura.
        </Subtitle>
        <CTAButton href="#formulario">
          Cadastrar minha cota agora
        </CTAButton>
      </Content>
      <ImageArea>
        <HeroImage src={familiaResort} alt="Família em resort ao pôr do sol" />
      </ImageArea>
    </HeroWrapper>
  );
};

export default HeroSection;


